export default __webpack_public_path__ + "static/media/banner_04.60ef7854.png";